export var VELT_SDK_VERSION = '4.5.0-beta.66';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '4.5.0-beta.66': 'sha384-pkP85zizrMhDMfqBdRLFSd/Ak4SQU3f9urYfXYrQLAslgrUBjX2djpGqcabgJjep',
};
